import gsap from "gsap";
import Splitting from "splitting";

const initAppearanceEffect = () => {

    [...document.querySelectorAll('[data-appear-effect]')]
        .filter(item => item.dataset.init !== 'true')
        .forEach((item) => {
            item.dataset.init = 'true';

            if (item.dataset.appearEffect) {
                let target;
                try {
                    target = item.querySelector(item.dataset.appearEffect);
                } catch (e) { }

                if (target) {
                    item = target;
                }
            }

            if(!item){
                return;
            }
            
            Splitting({ 
                target: item
            });
            const letters = item.querySelectorAll('.char');
            gsap.fromTo(
                letters,
                { opacity: 0.15 },
                {
                    opacity: 1,
                    stagger: 0.05,
                    ease: "power1.out",
                    
                    scrollTrigger: {
                        trigger: item,
                        end: "center 30%", 
                        start: "10% bottom",
                        scrub: 1,
                        toggleActions: "play none none reverse",
                    },
                }
            );
        });
};

const separateLetters = (element) => {
    const text = element.textContent;
    element.textContent = '';
    for (let char of text) {
        const span = document.createElement('span');
        span.textContent = char;
        span.style.font = 'inherit';
        span.style.color = 'inherit';
        element.appendChild(span);
    }
};

export { initAppearanceEffect };